import { useEffect } from 'react'
import { Skeleton } from 'components/Skeleton/Skeleton'
import cx from 'classnames'

import { useProseInstance } from 'providers/ProseInstanceProvider'
import { useInterval } from 'hooks/UseInterval'

import Styles from 'common/PropertiesList/PropertiesList.module.scss'
import { DocInfoPropertyListItem } from 'common/PropertyListItem/PropertyListItem'
import { useAssignedProperties } from 'hooks/useAssignedProperties'
import { AssigneeType } from 'api/clients/PropertyClient'

interface Props {
  assignee: {
    id: string
    type: AssigneeType
  }
  className?: string
}

export const DocInfoContainer = ({ assignee, className }: Props) => {
  const { currentViewRef } = useProseInstance()

  const { docInfoAssignedProperties, updateWordCountProperty, loading, loadMore } = useAssignedProperties({
    assignee,
    view: currentViewRef.current,
  })

  useEffect(() => {
    loadMore()
  }, [loadMore, assignee, currentViewRef])

  useInterval(() => {
    if (!currentViewRef.current) {
      return
    }
    updateWordCountProperty(docInfoAssignedProperties, currentViewRef.current)
  }, 1000)

  return (
    <div className={cx(Styles.container, className)} id="properties-list-container">
      {loading && !docInfoAssignedProperties.length && (
        <Skeleton title={false} paragraph={{ rows: 4, width: '100%' }} />
      )}
      <ul className={Styles.list}>
        {docInfoAssignedProperties.map(({ property, property_values }) => (
          <li className={cx(Styles.listItem, Styles.disabled)} key={property.id}>
            <DocInfoPropertyListItem
              assignee={assignee}
              property={property}
              selectedPropertyValues={property_values}
              disabled={true}
            />
          </li>
        ))}
      </ul>
    </div>
  )
}
